const env = {}
function initEnv() {
  return {
    set: (id, opts) => {
      env[id] = opts
    },
    get: (id) => {
      return env[id] || {}
    },
  }
}

export const envs = function () {
  if (process.env.NODE_ENV === 'development') {
    return 'dev'
  } else if (document.domain.includes('pre')) {
    return 'pre'
  } else if (document.domain.includes('rlab.sim.')) {
    return 'sim'
  } else {
    return 'prod'
  }
}

export const getSobHost = () => {
  const simFix = location.origin.split('.')[0].includes('sim')
    ? location.origin.split('.')[0]
    : 'http://sim060'

  const SOBHOST = {
    dev: simFix + '.www.rlab.sim.intra.xiaojukeji.com',
    sim: simFix + '.www.rlab.sim.intra.xiaojukeji.com',
    pre: 'https://pre.didi-food.com',
    prod: 'https://didi-food.com',
  }
  return SOBHOST[envs()]
}

export default initEnv()
